import { registerBlockType } from '@wordpress/blocks';
import Edit from './edit';
import save from './save';

import './editor.scss';

registerBlockType('juzeddev/juz-dualview', {
  edit: Edit,
  save,
});

